import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getShortCloseApprovalQuery = async (vendorId, purchaseOrderId, lineItemId) => {
  let url = `${apiurl?.getShortCloseApproval}?vendorId=${vendorId}&purchaseOrderId=${purchaseOrderId}`;

  if (lineItemId) {
    url += `&lineItemId=${lineItemId}`;
  }

  const response = await axios.get(url);
  return response.data;
};

const getShortCloseApproval = (vendorId, purchaseOrderId, lineItemId) => {
  return useQuery(
    ['getShortCloseApproval', vendorId, purchaseOrderId, lineItemId],
    () => getShortCloseApprovalQuery(vendorId, purchaseOrderId, lineItemId),
    {
      refetchOnWindowFocus: false
    }
  );
};

export { getShortCloseApprovalQuery };
export default getShortCloseApproval;
